// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-accordion ion-item ion-label {
  font-size: 15px;
}

ion-card {
  width: 100%;
}

ion-card-content {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/search-results/search-results/search-results.page.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":["ion-accordion ion-item ion-label {\r\n    font-size: 15px;\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n}\r\n\r\nion-card-content {\r\n    color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
